/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SendIcon from "@mui/icons-material/Send";
import {
  Button,
  Chip,
  IconButton,
  Link as LinkMui,
  Menu,
  MenuItem,
  Pagination,
  Stack,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { get, isEmpty, map, toString, find } from "lodash";
import { Link } from "react-router-dom";
import moment from "moment";

import { Alert, Notification, Question } from "../../../components/form";
import Table from "../../../components/form/TableFilter";
import { Checkbox as MuiCheckbox } from "@mui/material";
import Layout from "../../../components/layout/Layout";
import { PageSize, countPage } from "../../../config/const";
import { useCanView } from "../../../config/hook/UserPermissions";
import Toolbar from "./Toolbar";
import DteModal from "./DteModal";
import { getInvoiceClient }         from "../../../store/transactions/thunk/invoiceClient/getAll";
import { deleteInvoiceClient }      from "../../../store/transactions/thunk/invoiceClient/delete";
import { processOdooInvoiceClient } from "../../../store/transactions/thunk/invoiceClient/processOdoo";

const InvoiceClient = () => {
  const [__] = useTranslation("invoiceClient");
  const dispatch = useDispatch();
  const canView = useCanView();
  const [filter, setFilter] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [selected, setSelected] = useState({});
  const [showNoti, setShowNoti] = useState({
    open: false,
    msg: "",
    variant: "error",
    action: "post",
  });
  const [alert, setAlert] = useState({
    open: false,
    title: "",
    subtitle: "",
    type: "",
  });
  const [openQuestion, setOpenQuestion]       = useState(false);
  const [openOdooQuestion, setOpenOdooQuestion] = useState(false);
  const [selectedOdoo, setSelectedOdoo]         = useState({});
  const [openDteModal, setOpenDteModal]         = useState(false);
  const [selectedDteInvoiceId, setSelectedDteInvoiceId] = useState(null);

  const invoiceClient = useSelector((state) => state.transactions.invoiceClient);
  const delet         = useSelector((state) => state.transactions.invoiceClient.delete);
  const put           = useSelector((state) => state.transactions.invoiceClient.put);
  const processOdoo   = useSelector((state) => state.transactions.invoiceClient.processOdoo);

  const invoiceStatus = __(`invoiceStatus`, { returnObjects: true });

  const filterKeyMap = {
    validateSac:     "ValidaSac",
    transmittedOdoo: "TransmitidoErp",
    odooStatus:      "invoice_status",
    odooSO:          "OdooSOname",
    status:          "Estado",
    invoiceNumber:   "InvoiceId",
    date:            "Fecha",
    clientCode:      "CustomerID",
    clientName:      "CustomerName",
    division:        "Division",
    invoiceType:     "InvoiceTipo",
    subTotal:        "DocSubTotal",
    totalIva:        "TaxTotal",
    total:           "DocTotal",
    lines:           "Lineas",
    dte:             "Dte",
    dteDate:         "create_date",
    dteAmount:       "amount_total",
  };

  const getData = ({ page, filters = filter }) => {
    const cleanFilters = Object.fromEntries(
      Object.entries(filters)
        .filter(([, v]) => v !== "" && v !== undefined && v !== null)
        .map(([k, v]) => [filterKeyMap[k] ?? k, v]),
    );
    dispatch(getInvoiceClient({ page, ...cleanFilters, Export: false }));
  };

  const reload = () => getData({ page: 1 });

  useEffect(() => {
    setAnchorEl(false);
    getData({ page: 1 });
  }, []);

  const debounceRef = useRef(null);

  const onFilterChange = (key, value) => {
    if (key === "date") {
      const { from, to } = value || {};
      const updatedFilters = { ...filter };
      delete updatedFilters["date"];
      if (from) updatedFilters["Fecha.FechaInicio"] = from;
      else delete updatedFilters["Fecha.FechaInicio"];
      if (to) updatedFilters["Fecha.FechaFin"] = to;
      else delete updatedFilters["Fecha.FechaFin"];
      setFilter(updatedFilters);
      getData({ page: 1, filters: updatedFilters });
      return;
    }

    if (key === "dteDate") {
      const { from, to } = value || {};
      const updatedFilters = { ...filter };
      delete updatedFilters["dteDate"];
      if (from) updatedFilters["create_date.FechaInicio"] = from;
      else delete updatedFilters["create_date.FechaInicio"];
      if (to) updatedFilters["create_date.FechaFin"] = to;
      else delete updatedFilters["create_date.FechaFin"];
      setFilter(updatedFilters);
      getData({ page: 1, filters: updatedFilters });
      return;
    }

    const updatedFilters = { ...filter, [key]: value };
    setFilter(updatedFilters);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (typeof value === "boolean" || value === "") {
      getData({ page: 1, filters: updatedFilters });
    } else if (value.length >= 3) {
      debounceRef.current = setTimeout(() => {
        getData({ page: 1, filters: updatedFilters });
      }, 300);
    }
  };

  const handleOpenMenu = (row) => (event) => {
    setSelected(row);
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setSelected({});
    setAnchorEl(null);
  };

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" });
  };

  const setError = (err) => {
    if (!isEmpty(err) && !!get(err, "Message", "")) {
      setAlert({
        open: true,
        title: get(err, "Message", ""),
        subtitle: (
          <ul>
            {map(get(err, "ValidationError", []), (item) => (
              <li>{`• ${item}`}</li>
            ))}
          </ul>
        ),
        type: "error",
        func: closeAlert,
      });
    } else {
      setAlert({ open: true, type: "default", func: closeAlert });
    }
    handleCloseMenu();
  };

  const onDelete = () => {
    dispatch(deleteInvoiceClient(get(selected, "invoiceId")));
    setSelected({});
  };

  const handleDelete = (row) => () => {
    setAnchorEl(null);
    setOpenQuestion(true);
    setSelected(row);
  };

  useEffect(() => {
    if (get(delet, "isSuccess", false)) {
      setOpenQuestion(false);
      reload();
      setShowNoti({ open: true, msg: "", variant: "success", action: "delet" });
    }
    if (get(delet, "isReject", false)) {
      setError(get(delet, "error", {}));
    }
    if (get(put, "isSuccess", false)) {
      handleCloseMenu();
      getData({ page: 1, filter });
      setShowNoti({ open: true, msg: "", variant: "success", action: "put" });
    }
    if (get(put, "isReject", false)) {
      setError(get(put, "error", {}));
    }
  }, [put, delet]);

  useEffect(() => {
    if (get(processOdoo, "isSuccess", false)) {
      setOpenOdooQuestion(false);
      setSelectedOdoo({});
      reload();
      setShowNoti({ open: true, msg: "", variant: "success", action: "put" });
    }
    if (get(processOdoo, "isReject", false)) {
      setError(get(processOdoo, "error", {}));
    }
  }, [processOdoo]);


  const headTable = [
    {
      key: "sendOdoo",
      label: __(`table.cols.sendOdoo`),
      align: "center",
      sx: { minWidth: 80 },
    },
    {
      key: "validateSac",
      label: __(`table.cols.validateSac`),
      align: "center",
      sx: { minWidth: 80 },
      filterType: "bool",
    },
    {
      key: "transmittedOdoo",
      label: __(`table.cols.transmittedOdoo`),
      align: "center",
      sx: { minWidth: 140 },
    },
    {
      key: "odooStatus",
      label: __(`table.cols.odooStatus`),
      align: "center",
      sx: { minWidth: 120 },
    },
    {
      key: "odooSO",
      label: __(`table.cols.odooSO`),
      align: "center",
      sx: { minWidth: 100 },
    },
    {
      key: "status",
      label: __(`table.cols.status`),
      align: "center",
      sx: { minWidth: 130 },
    },
    {
      key: "invoiceNumber",
      label: __(`table.cols.invoiceNumber`),
      align: "center",
      sx: { minWidth: 110 },
    },
    {
      key: "date",
      label: __(`table.cols.date`),
      align: "center",
      sx: { minWidth: 110 },
      filterType: "dateRange",
    },
    {
      key: "clientCode",
      label: __(`table.cols.clientCode`),
      align: "center",
      sx: { minWidth: 120 },
    },
    {
      key: "clientName",
      label: __(`table.cols.clientName`),
      align: "left",
      sx: { minWidth: 180 },
    },
    {
      key: "division",
      label: __(`table.cols.division`),
      align: "center",
      sx: { minWidth: 100 },
    },
    {
      key: "invoiceType",
      label: __(`table.cols.invoiceType`),
      align: "center",
      sx: { minWidth: 120 },
    },
    {
      key: "subTotal",
      label: __(`table.cols.subTotal`),
      align: "right",
      sx: { minWidth: 110 },
    },
    {
      key: "totalIva",
      label: __(`table.cols.totalIva`),
      align: "right",
      sx: { minWidth: 110 },
    },
    {
      key: "total",
      label: __(`table.cols.total`),
      align: "right",
      sx: { minWidth: 110 },
    },
    {
      key: "lines",
      label: __(`table.cols.lines`),
      align: "center",
      sx: { minWidth: 80 },
    },
    {
      key: "dte",
      label: __(`table.cols.dte`),
      align: "center",
      sx: { minWidth: 100 },
    },
    {
      key: "dteDate",
      label: __(`table.cols.dteDate`),
      align: "center",
      sx: { minWidth: 110 },
      filterType: "dateRange",
    },
    {
      key: "dteAmount",
      label: __(`table.cols.dteAmount`),
      align: "right",
      sx: { minWidth: 110 },
    },
    {
      key: "options",
      label: "",
      align: "center",
      sx: {
        width: 50,
        position: "sticky",
        right: 0,
        pr: 1,
        background:
          "linear-gradient(90deg, hsla(0, 0%, 100%, 1) 0%, hsla(0, 0%, 87%, 1) 8px, hsla(0, 0%, 100%, 1) 8px, hsla(0, 0%, 100%, 1) 100%)",
      },
    },
  ];

  const dataTable = map(get(invoiceClient, "data.data", []), (row) => {
    const statusItem = find(
      invoiceStatus,
      ({ label }) => label === get(row, "estado"),
    );

    return {
      ...row,
      sendOdoo: (
        <Button
          variant="outlined"
          color="secondary"
          size="small"
          disabled={get(processOdoo, "isLoading") && get(selectedOdoo, "invoiceId") === get(row, "invoiceId")}
          title={__(`table.cols.sendOdoo`)}
          onClick={() => {
            if (canView("TRANSACCIONES/INVOICES/PROCESAR", "add")) {
              setSelectedOdoo(row);
              setOpenOdooQuestion(true);
            } else {
              setAlert({ open: true, title: "Permiso Denegado.", subtitle: (<ul><li>• No tienes permiso para enviar a Odoo.</li></ul>), type: "error", func: closeAlert });
            }
          }}
        >
          <SendIcon fontSize="small" />
        </Button>
      ),
      invoiceNumber: (
        <LinkMui component={Link} to={toString(get(row, "invoiceId"))}>
          {get(row, "invoiceId")}
        </LinkMui>
      ),
      status: (
        <Chip
          label={get(statusItem, "label", get(row, "estado", "-"))}
          sx={{
            bgcolor: `${get(statusItem, "color", "#ccc")}26`,
            color: get(statusItem, "color", "#666"),
          }}
        />
      ),
      validateSac: (
        <MuiCheckbox
          checked={!!get(row, "validaSac")}
          size="small"
          color="secondary"
          disableRipple
          sx={{ padding: 0, pointerEvents: "none" }}
        />
      ),
      date: get(row, "fecha")
        ? moment(get(row, "fecha")).format("DD/MM/YYYY")
        : "-",
      clientCode: get(row, "customerID", "-"),
      clientName: get(row, "customerName", "-"),
      invoiceType: get(row, "invoiceTipo", "-"),
      transmittedOdoo: (() => {
        const val = get(row, "transmitidoErp");
        if (!val) return "-";
        const isOk = val.toUpperCase() === "OK";
        const color = isOk ? "#03BE06" : "#ff0000";
        return (
          <Chip
            label={val}
            size="small"
            onClick={() => {
              setSelectedDteInvoiceId(get(row, "invoiceId"));
              setOpenDteModal(true);
            }}
            sx={{ bgcolor: `${color}26`, color, fontWeight: 600, cursor: "pointer" }}
          />
        );
      })(),
      odooStatus: get(row, "invoice_status", "-"),
      odooSO: get(row, "odooSOname", "-"),
      subTotal:
        get(row, "docSubTotal") != null
          ? `$ ${Number(get(row, "docSubTotal")).toFixed(2)}`
          : "-",
      totalIva:
        get(row, "taxTotal") != null
          ? `$ ${Number(get(row, "taxTotal")).toFixed(2)}`
          : "-",
      total:
        get(row, "docTotal") != null
          ? `$ ${Number(get(row, "docTotal")).toFixed(2)}`
          : "-",
      lines: get(row, "lineas", "-"),
      dte: get(row, "dte", "-"),
      dteDate: get(row, "create_date")
        ? moment(get(row, "create_date")).format("DD/MM/YYYY")
        : "-",
      dteAmount:
        get(row, "amount_total") != null
          ? `$ ${Number(get(row, "amount_total")).toFixed(2)}`
          : "-",
      options: (
        <IconButton aria-label="more" size="small" onClick={handleOpenMenu(row)}>
          <MoreVertIcon fontSize="inherit" />
        </IconButton>
      ),
    };
  });

  const onChangePagination = (e, page) => getData({ page, filter });

  return (
    <Layout
      propsToolbar={{
        title: __(`head.name`),
        code: null,
        btnLabel: null,
      }}
    >
      <Toolbar
        __={__}
        reload={reload}
        data={get(invoiceClient, "data.data", [])}
      />
      <Table
        headTable={headTable}
        dataTable={dataTable}
        __={__}
        sizeFilters={125}
        propsTable={{ showFilterRow: true }}
        filters={filter}
        onFilterChange={onFilterChange}
        loading={get(invoiceClient, "isLoading", false)}
      />
      <Stack sx={{ mt: 2 }} alignItems="flex-end">
        <Pagination
          count={countPage(get(invoiceClient, "data.totalRecord", 1))}
          page={get(invoiceClient, "data.currentPage", 1)}
          onChange={onChangePagination}
          color="secondary"
          sx={{ "& li > button": { borderRadius: 1 } }}
          disabled={get(invoiceClient, "isLoading", false)}
        />
      </Stack>
      <Menu
        id="invoice-client-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
        MenuListProps={{ "aria-labelledby": "basic-button" }}
        transformOrigin={{ horizontal: "right", vertical: "center" }}
        anchorOrigin={{ horizontal: "left", vertical: "center" }}
      >
        {get(selected, "invoiceId") && (
          <Link to={toString(get(selected, "invoiceId"))}>
            <MenuItem>{__(`table.menu.edit`)}</MenuItem>
          </Link>
        )}
        <MenuItem onClick={handleDelete(selected)}>
          {__(`table.menu.delete`)}
        </MenuItem>
      </Menu>
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />
      <Question
        title={__("alert.deleteItem.title")}
        detail={__("alert.deleteItem.detail")}
        onSuccess={onDelete}
        onCancel={() => setOpenQuestion(false)}
        open={openQuestion}
        loading={get(delet, "isLoading")}
      />
      <Question
        title={__("alert.processOdoo.title")}
        detail={__("alert.processOdoo.detail")}
        onSuccess={() => dispatch(processOdooInvoiceClient(get(selectedOdoo, "invoiceId")))}
        onCancel={() => { setOpenOdooQuestion(false); setSelectedOdoo({}); }}
        open={openOdooQuestion}
        loading={get(processOdoo, "isLoading")}
      />
      <DteModal
        open={openDteModal}
        onClose={() => { setOpenDteModal(false); setSelectedDteInvoiceId(null); }}
        invoiceId={selectedDteInvoiceId}
      />
    </Layout>
  );
};

export default InvoiceClient;
